import React from "react";
import PropTypes from "prop-types";

function DescriptionField(props) {
  var id = props.id,
      description = props.description;

  if (!description) {
    return null;
  }

  if (typeof description === "string") {
    return (
      /*#__PURE__*/
      React.createElement("p", {
        id: id,
        className: "field-description"
      }, description)
    );
  } else {
    return (
      /*#__PURE__*/
      React.createElement("div", {
        id: id,
        className: "field-description"
      }, description)
    );
  }
}

if (process.env.NODE_ENV !== "production") {
  DescriptionField.propTypes = {
    id: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  };
}

export default DescriptionField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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